import curry from './curry'
import mergeWithKey from './mergeWithKey'

/**
 * Creates a new object with the own properties of the two provided objects
 * if a key exists in both objects:
 *   - if both associated values are also objects then the alues will be
 *     recursiely merged
 *   - otherwise the provided function is applied to the key and associated values
 *     with the resulting alue as the new value associated with the key
 *
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object
 *
 * const concatValues = (key, obj1, obj2) => key === 'values' ? concatFn(obj1, obj2) : obj2
 * const merged = mergeDeepWithKey(concatValues,
 *   { a: true, c: { thing: 'foo', values: [10, 20] } },
 *   { b: true, c: { thing: 'bar', values: [15, 35] } }
 * )
 * merged -> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */

const mergeDeepWithKey = curry((fn, obj1, obj2) => {
	return mergeWithKey((key, obj1Val, obj2Val) => {
		if (typeof obj1Val === 'object' && typeof obj2Val === 'object') {
			return mergeDeepWithKey(fn, obj1Val, obj2Val)
		} else {
			return fn(key, obj1Val, obj2Val)
		}
	}, obj1, obj2)
}) 

export default mergeDeepWithKey
